import { Checkbox, Collapse, Typography } from 'antd';
import { FC } from 'react';

import styles from './styles.module.scss';

const { Text } = Typography;

interface IColumnVisibilityPanelProps {
  columns: { key: string; label: string }[];
  visibleColumns: Record<string, boolean>;
  onChange: (key: string, checked: boolean) => void;
  ghost?: boolean;
}

const ColumnVisibilityPanel: FC<IColumnVisibilityPanelProps> = ({
  columns,
  visibleColumns,
  onChange,
  ghost = false,
}) => {
  return (
    <Collapse
      bordered={ghost ? undefined : false}
      ghost={ghost}
      style={{ background: 'transparent', marginBottom: 8 }}
      className={styles.collapse}
    >
      <Collapse.Panel
        key="colvis"
        header={
          <Text strong style={{ color: '#0e4d8f' }}>
            Column Visibility
          </Text>
        }
      >
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '6px 20px' }}>
          {columns.map(({ key, label }) => (
            <Checkbox
              key={key}
              checked={visibleColumns[key]}
              onChange={(e) => onChange(key, e.target.checked)}
            >
              {label}
            </Checkbox>
          ))}
        </div>
      </Collapse.Panel>
    </Collapse>
  );
};

export default ColumnVisibilityPanel;
